function lazyYT() {
	$('.lazyYT').lazyYT();
}